/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Descarregar na App Store",
      "Encontra grupos por perto",
      "Liga-te a pessoas como tu nos Hives.",
      "Encontra pessoas como tu",
      "Se tens uma paixão, há um Hive para ti!",
      "Aqui, podes ser tu mesmo",
      "Escolhe entre Hives ocultos ou visíveis.",
      "Começar",
      "Se tens uma paixão, há um Hive para ti",
      "Encontra um novo grupo de pessoas nos Hives ou no Bumble BFF",
      "Tens um convite para o Hives",
      "Conhece novos grupos de pessoas na tua área com o novo recurso do Bumble BFF, o Hives. Cria já o teu perfil BFF na aplicação Bumble.",
      "Obter no Google Play",
      "Gerir Cookies",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "dias"
            ],
            "singular": [
                  "dia"
            ]
      },
      "hour": {
            "plural": [
                  "horas"
            ],
            "singular": [
                  "hora"
            ]
      },
      "minute": {
            "plural": [
                  "minutos"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "meses"
            ],
            "singular": [
                  "mês"
            ]
      },
      "second": {
            "plural": [
                  "segundos"
            ],
            "singular": [
                  "segundo"
            ]
      },
      "year": {
            "plural": [
                  "anos"
            ],
            "singular": [
                  "ano"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
